import { knowledgeEnTranslations } from './knowledge.en';
import { knowledgeHeTranslations } from './knowledge.he';

export const knowledgeTranslations = {
  en: knowledgeEnTranslations,
  he: knowledgeHeTranslations,
};
